module.exports = __webpack_public_path__ + "assets/img/5.e6f4c026.png";